// Stub parser for a hardcoded rule. Number == Number
import {assert} from 'Asserts';
import {BenchlingExpression, BenchlingExpressionType} from 'benchling-expressions/BenchlingExpressionTypes';
import {DeepPartial} from 'util/Types';

// Formula to json representation of the benchling expression client spec
// Define index signature for hardCodedFormulas
export const HARDCODED_FORMULAS: Record<string, {expression: unknown}> = {
  // A rule that is always true
  '12 == 12': {
    // The value of expression is the client spec
    expression: {
      type: 'FUNCTION',
      name: 'EQUALS',
      parameters: [
        {
          expression: {
            type: 'CONSTANT_VALUE',
            itemType: {
              name: 'Integer',
              ofType: null,
              selectorId: null,
            },
            value: 12,
          },
          name: 'value1',
        },
        {
          expression: {
            type: BenchlingExpressionType.CONSTANT_VALUE,
            itemType: {
              name: 'Integer',
              ofType: null,
              selectorId: null,
            },
            value: 12,
          },
          name: 'value2',
        },
      ],
    },
  },
  // A rule that is always false
  '12 != 12': {
    // The value of expression is the client spec
    expression: {
      type: 'FUNCTION',
      name: 'NOT_EQUALS',
      parameters: [
        {
          expression: {
            type: 'CONSTANT_VALUE',
            itemType: {
              name: 'Integer',
              ofType: null,
              selectorId: null,
            },
            value: 12,
          },
          name: 'value1',
        },
        {
          expression: {
            type: BenchlingExpressionType.CONSTANT_VALUE,
            itemType: {
              name: 'Integer',
              ofType: null,
              selectorId: null,
            },
            value: 12,
          },
          name: 'value2',
        },
      ],
    },
  },
};

export function parseFormula(formula: string): DeepPartial<BenchlingExpression> {
  if (HARDCODED_FORMULAS[formula] == null) {
    assert(false, `Could not find formula ${formula}`);
  }
  if (HARDCODED_FORMULAS[formula].expression == null) {
    assert(false, `Could not find expression for formula ${formula}`);
  }
  return HARDCODED_FORMULAS[formula].expression as DeepPartial<BenchlingExpression>;
}

export function formatExpression(expression: BenchlingExpression): string {
  if (expression.type === 'FUNCTION' && expression.name === 'EQUALS') {
    return '12 == 12';
  } else if (expression.type === 'FUNCTION' && expression.name === 'NOT_EQUALS') {
    return '12 != 12';
  }
  assert(false, `Could not find formula for expression ${JSON.stringify(expression)}`);
}
